import { useEffect, useRef } from 'react';

/**
 * Use previous value (for mimicking functionality like prevProps in class components)
 * @see {@link https://usehooks.com/usePrevious/}
 */
export function usePrevious<S>(value: S) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef<S>();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
